/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { partitionsSetLimits } from "../../funcs/partitionsSetLimits.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .SetPartitionLimitsPartitionsPartitionIdLimitsPutRequest$inboundSchema,
};

export const tool$partitionsSetLimits: ToolDefinition<typeof args> = {
  name: "partitions-set-limits",
  description: `Set Partition Limits

Sets limits on a partition. Limits can be set on the total number of pages a partition can host and process. When the limit is reached, the partition will be disabled. A limit may be removed by setting it to \`null\`.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await partitionsSetLimits(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
